<template>
  <div class="header">
    <header>
      <!-- 导航栏 -->
      <el-row class="tabBar">
        <el-col :xs="22" :sm="22" :md="22" :lg="11" :xl="11" class="header_tit">
          <img src="../assets/image/logo.jpg" alt="" />
          <span>泰州市峰润洗涤服务有限公司</span>
        </el-col>

        <el-col
          :xs="24"
          :sm="24"
          :md="24"
          :lg="13"
          :xl="13"
          class="header_tab"
          v-if="screenSize"
        >
          <el-menu
            :default-active="activeIndex"
            class="el-menu-demo"
            mode="horizontal"
            @select="tabSelect"
            background-color="#fff"
            text-color="#000"
            active-text-color="#1F948D"
          >
            <el-menu-item index="1">首页</el-menu-item>
            <el-menu-item index="2">企业简介</el-menu-item>
            <el-menu-item index="3">新闻</el-menu-item>
            <el-menu-item index="4">业务</el-menu-item>
            <el-menu-item index="5">联系我们</el-menu-item>
            <el-menu-item index="6">服务单位</el-menu-item>
            <el-menu-item index="7">员工通道</el-menu-item>
          </el-menu>
        </el-col>

        <el-dropdown
          :xs="4"
          :sm="4"
          :md="4"
          :lg="4"
          :xl="4"
          class="dropdown"
          v-else
          trigger="click"
          @command="tabSelect"
        >
          <span class="el-dropdown-link">
            <i class="el-icon-more"></i>
          </span>
          <el-dropdown-menu slot="dropdown">
            <el-dropdown-item command="1">首页</el-dropdown-item>
            <el-dropdown-item command="2">企业简介</el-dropdown-item>
            <el-dropdown-item command="3">新闻</el-dropdown-item>
            <el-dropdown-item command="4">业务</el-dropdown-item>
            <el-dropdown-item command="5">联系我们</el-dropdown-item>
            <el-dropdown-item command="6">服务单位</el-dropdown-item>
            <el-dropdown-item command="7">员工通道</el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>
      </el-row>
    </header>
  </div>
</template>

<script>
export default {
  name: "ComponentHeader",
  props: ["index"],
  data() {
    return {
      activeIndex: "",
      // 屏幕
      screenSize: "",
    };
  },
  methods: {
    //   监听窗口
    listener() {
      const that = this;
      window.addEventListener(
        "resize",
        function () {
          that.setSize();
        },
        false
      );
    },
    setSize() {
      var width =
        window.innerWidth ||
        document.documentElement.clientWidth ||
        document.body.clientWidth;
      let bannerHeight;
      let bannerHeight2;
      let bannerHeight3;
      //   设置图片高
      if (width < 992) {
        bannerHeight = (470 / 700) * width - 50 + "px";
        bannerHeight2 = (440 / 700) * width - 50 + "px";
        bannerHeight3 = (1000 / 1500) * width - 50 + "px";
      } else {
        bannerHeight = (470 / 850) * width - 50 + "px";
        bannerHeight2 = (470 / 850) * width - 50 + "px";
      }
      // 首页企业简介轮播
      if (!window.location.hash.split("/")[1] && width < 992) {
        document.getElementById("qyjj").style.height = bannerHeight3 + "px";
      }
      this.$emit("setHeight", [bannerHeight2, bannerHeight3]);

      if (window.location.hash.split("/")[1]) {
        document.getElementById("image").style.height = bannerHeight;
      } else {
        document.getElementById("el-carousel__container").style.height =
          bannerHeight2 + "px";
      }
      //   轮播

      //   显示元素
      if (document.documentElement.clientWidth < 992) {
        this.screenSize = false;
      } else {
        this.screenSize = true;
      }
    },
    //   tab切换
    tabSelect(key) {
      switch (key) {
        case "1":
          this.$router.push("/");
          break;
        case "2":
          this.$router.push("/CompanyIntr");
          break;
        case "3":
          this.$router.push("/news");
          break;
        case "4":
          this.$router.push("/business");
          break;
        case "5":
          this.$router.push("/connect");
          break;
        case "6":
          this.$router.push("/fwdw");
          break;
        case "7":
          window.location.replace("http://tzfr.fengrunxidi.cn/#/dashboard");
          break;
      }
    },
  },
  mounted() {
    this.activeIndex = this.index;
    this.listener();
    this.setSize();
  },
};
</script>

<style scoped lang="less">
.header {
  header {
    text-align: center;
    font-size: 0.14rem;
    font-weight: bolder;
    .tabBar {
      font-weight: normal;
      font-family: "Microsoft YaHei";
      display: flex;
      flex-wrap: wrap;
      //   justify-content: space-around;
      justify-content: space-between;
      .header_tit {
        font-size: 0.14rem;
        font-weight: bold;
        color: #1f948d;
        display: flex;
        justify-content: flex-start;
        align-content: center;
        img {
          width: 0.864rem !important;
          height: 0.6rem !important;
        }
        span {
          display: inline-block;
          &::before {
            display: inline-block;
            content: "";
            height: 100%;
            vertical-align: middle;
          }
        }
      }
      .header_tab {
        display: flex;
        justify-content: flex-end;
        ul {
          border: 0;
          li {
            font-size: 0.09rem;
            font-weight: bold;
          }
        }
        ul.el-menu {
          display: flex;
          flex-wrap: wrap;
          align-items: center;
        }
      }
      .dropdown {
        font-size: 200%;
        display: flex;
        align-items: center;
        .el-dropdown-link {
          cursor: pointer;
          color: #1f948d;
        }
        .el-icon-arrow-down {
          //   font-size: 12px;
        }
      }
    }
  }
}
</style>
